import { useEffect, useRef, useState } from 'react';
import { Box, Textarea, Tooltip } from '@chakra-ui/react';
import { isEmpty } from '../../helpers';

type TTextInput = {
  name: string;
  value: string;
  isDisabled: boolean;
  handleOnChange: (name: string, value: string) => void;
  bgColor?: string;
};

const TextInput = ({
  name,
  value,
  isDisabled,
  bgColor,
  handleOnChange,
}: TTextInput) => {
  const ref = useRef<any>();

  const [isFocus, setIsFocus] = useState(false);
  const [needTooltip, setNeedTooltip] = useState(false);

  useEffect(() => {
    if (isFocus && value) {
      ref.current.style.height = '35px';
      ref.current.style.height = `${ref.current.scrollHeight + 2}px`;
    } else {
      ref.current.style.height = '35px';
    }

    setNeedTooltip(ref.current?.scrollHeight + 2 > 35);
  }, [isFocus, value]);

  const squeezedValue = isEmpty(value)
    ? null
    : isFocus
      ? value
      : `${value}`?.replace(/\n|\r/g, ' - ');

  return (
    <Box w='100%' position='relative' h='35px'>
      <Tooltip
        label={value ?? ''}
        variant='form'
        whiteSpace='pre-line'
        display={!isFocus && needTooltip ? 'auto' : 'none'}
        bgColor='#f9fafb'
        color='#1a202c'
        placement='bottom-start'
        p={3}
        boxShadow='dark-lg'
        fontWeight='400'
        borderRadius='3px'
      >
        <Textarea
          position='absolute'
          ref={ref}
          onFocus={() => setIsFocus(true)}
          onBlur={() => setIsFocus(false)}
          isDisabled={isDisabled}
          p={2}
          minH='35px'
          height='35px'
          maxW='100%'
          onChange={(e) => {
            handleOnChange(name, e.target.value);
          }}
          value={squeezedValue ?? ''}
          bgColor={bgColor}
          maxH={!isFocus ? '35px' : ''}
        />
      </Tooltip>
    </Box>
  );
};

export default TextInput;
